export default __webpack_public_path__ + "assets/tuvalu-flag.png";